import React from "react";

import { Grid, Slide } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import { TemporaryBusinessWarnings } from "components/DeploymentSaleSummaries/TemporaryBusinessWarnings";
import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { ReviewCard, ReviewField } from "components/ReviewCard";
import { MediumMobileCard } from "components/SaleSummaryCards/Cards";
import { CompactCardStack } from "components/SaleSummaryCards/Common";
import { TitleText } from "components/Text";

import { ApiModel } from "constants/loading";

import { dateTimeStringToDateTime, formatDateString } from "lib/timeFormats";

import {
  getBidders,
  getConsignments,
  getCurrentSale,
  getSaleLots,
  selectAlphabeticalBuyerIds,
} from "selectors";
import { getEffectiveSaleTitleBySaleId } from "selectors/sales";

const SummaryGrid = styled(Grid)`
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const ReviewCardsSection = styled.div`
  padding: ${({ theme }) => theme.space[2]}px;
`;

export const ClearingSaleOverview = () => {
  const sale = useSelector(getCurrentSale);
  const effectiveTitle = useSelector(
    getEffectiveSaleTitleBySaleId(sale.livestocksale_id),
  );
  const consignments = Object.values(useSelector(getConsignments));
  const saleLots = Object.values(useSelector(getSaleLots));
  const buyerCount = useSelector(selectAlphabeticalBuyerIds).length;
  const bidderCount = Object.keys(useSelector(getBidders)).length;

  const vendorCount = new Set(
    consignments.map(consignment => consignment.vendor_id).filter(Boolean),
  ).size;
  const soldCount = saleLots.filter(saleLot => saleLot.buyer_id).length;

  return (
    <WaitForSync
      requiredData={[
        ApiModel.CONSIGNMENTS,
        ApiModel.SALE_LOTS,
        ApiModel.BUSINESSES,
        ...(sale.using_registered_bidders ? [ApiModel.BIDDERS] : []),
      ]}
    >
      <Slide in direction="right">
        <SummaryGrid container justifyContent="space-evenly">
          <Grid item xs={12}>
            <TitleText center block>
              {effectiveTitle}
            </TitleText>
          </Grid>
          <Grid item container xs={12} justifyContent="center">
            <Container disableGutters>
              <CompactCardStack>
                <MediumMobileCard
                  title="Sale Date"
                  value={
                    sale.date
                      ? formatDateString(dateTimeStringToDateTime(sale.date))
                      : "-"
                  }
                />
                <MediumMobileCard title="Vendors" value={vendorCount} />
                <MediumMobileCard title="Lots" value={saleLots.length} />
                <MediumMobileCard title="Sold" value={soldCount} />
                {sale.using_registered_bidders && (
                  <MediumMobileCard title="Bidders" value={bidderCount} />
                )}
                <MediumMobileCard title="Buyers" value={buyerCount} />
              </CompactCardStack>
            </Container>
          </Grid>
          {sale.notes && (
            <Grid item xs={12}>
              <ReviewCardsSection>
                <ReviewCard>
                  <ReviewField>{sale.notes}</ReviewField>
                </ReviewCard>
              </ReviewCardsSection>
            </Grid>
          )}
          <Grid item container xs={12} justifyContent="center">
            <Container disableGutters>
              <TemporaryBusinessWarnings />
            </Container>
          </Grid>
        </SummaryGrid>
      </Slide>
    </WaitForSync>
  );
};
